import { useCallback, useEffect, useState } from 'react';
import { SELECTED_AUDIO_OUTPUT_KEY } from '@uplift/constants';
import { localStorage } from '@uplift/services';
import { useDevices } from './use-devices';


export const useActiveSinkId = () => {
  const { audioOutputDevices } = useDevices();

  const selectedSinkId = localStorage.getItem(SELECTED_AUDIO_OUTPUT_KEY);

  const [ activeSinkId, _setActiveSinkId ] = useState(selectedSinkId || 'default');

  const setActiveSinkId = useCallback(
    (sinkId: string) => {
      localStorage.setItem(SELECTED_AUDIO_OUTPUT_KEY, sinkId);
      _setActiveSinkId(sinkId);
    },
    [ _setActiveSinkId ]
  );

  useEffect(() => {
    const selectedSinkId = localStorage.getItem(SELECTED_AUDIO_OUTPUT_KEY);
    const hasSelectedAudioOutputDevice = audioOutputDevices.some(
      device => selectedSinkId && device.deviceId === selectedSinkId
    );

    if (hasSelectedAudioOutputDevice) {
      _setActiveSinkId(selectedSinkId!);
    }
  }, [ audioOutputDevices ]);

  return { activeSinkId, setActiveSinkId };
};
